/**
 * 参数管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.comm.ECSETTINGS + "/" + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.comm.ECSETTINGS, METHOD.POST, result);
	},
}


export default {dataApi}